import React, { Component } from 'react';
import { Cpu, UserRound, Stethoscope } from 'lucide-react';
import './Login.css';

class Login extends Component {
    constructor(props) {
        super(props);
        this.state = {
            username: '',
            password: '',
            selectedRole: 'DOKTOR',
        };
    }

    handleInputChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    handleRoleChange = (role) => {
        this.setState({ selectedRole: role });
    };

    handleLogin = () => {
        const { username, password, selectedRole } = this.state;
        this.props.onLogin(username, password, selectedRole);
    };

    render() {
        const { selectedRole, username, password } = this.state;

        return (
            <div className="login-container">
                <div className="login-box">
                    <div className="login-logo">
                        <Cpu size={32} />
                    </div>
                    <h1>Welcome to ClinicPro</h1>
                    <p>Select your role and enter your credentials to log in.</p>

                    <div className="role-selector">
                        <button
                            className={`role-btn ${selectedRole === 'DOKTOR' ? 'active' : ''}`}
                            onClick={() => this.handleRoleChange('DOKTOR')}
                        >
                            <Stethoscope size={28} />
                            <span>Doctor</span>
                        </button>
                        <button
                            className={`role-btn ${selectedRole === 'SEKRETER' ? 'active' : ''}`}
                            onClick={() => this.handleRoleChange('SEKRETER')}
                        >
                            <UserRound size={28} />
                            <span>Secretary</span>
                        </button>
                    </div>

                    <div className="form-group">
                        <label htmlFor="username">Username</label>
                        <input
                            type="text"
                            id="username"
                            name="username"
                            value={username}
                            onChange={this.handleInputChange}
                        />
                    </div>
                    <div className="form-group">
                        <label htmlFor="password">Password</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            value={password}
                            onChange={this.handleInputChange}
                        />
                    </div>
                    <button className="login-btn" onClick={this.handleLogin}>
                        Login
                    </button>

                    <div className="demo-accounts">
                        <h4>Demo Accounts</h4>
                        <div className="demo-account">
                            <strong>Doctor:</strong> <span>doktor / 1234</span>
                        </div>
                        <div className="demo-account">
                            <strong>Secretary:</strong> <span>sekreter / 1234</span>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Login;
